import { Component } from '@angular/core';
import { ErrorBlobComponent } from '@shared/components/error-blob/error-blob.component';

@Component({
  selector: 'app-error-400',
  imports: [
    ErrorBlobComponent
  ],
  templateUrl: './error-400.component.html',
  styleUrl: './error-400.component.css'
})
export class Error400Component {

}
